<template>
  <div
    v-if="connectionStore.shouldShowWarning"
    class="pointer-events-none fixed inset-x-0 bottom-6 z-[1300] flex justify-center px-4"
  >
    <div
      role="status"
      aria-live="polite"
      class="pointer-events-auto flex max-w-xl items-center gap-3 rounded-full border border-amber-200 bg-amber-50 px-4 py-3 shadow-lg ring-1 ring-black/5 dark:border-amber-500/30 dark:bg-amber-950 dark:ring-white/10 sm:px-5"
    >
      <ExclamationTriangleIcon
        class="size-5 shrink-0 text-amber-600 dark:text-amber-300"
        aria-hidden="true"
      />
      <p class="text-sm font-medium text-amber-950 dark:text-amber-100">
        You’re offline. Check your connection, then retry.
      </p>
      <div class="flex shrink-0 items-center gap-1.5">
        <button
          type="button"
          class="rounded-full bg-amber-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-amber-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600 dark:bg-amber-400 dark:text-amber-950 dark:hover:bg-amber-300"
          @click="connectionStore.retry"
        >
          Retry
        </button>
        <button
          type="button"
          class="rounded-full px-3 py-1.5 text-sm font-medium text-amber-900 hover:bg-amber-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600 dark:text-amber-100 dark:hover:bg-amber-900"
          aria-label="Dismiss realtime connection warning"
          @click="connectionStore.dismissWarning"
        >
          Dismiss
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'
import { useConnectionStore } from '@/stores/connectionStore'

const connectionStore = useConnectionStore()
</script>
